'use client'
import { useEffect, useRef } from 'react'

import { Section, useThemeStore } from '@/components/findex-connect/store/ThemeStore'
import { HowItWorksBlockSb } from '@/components/findex-connect/types/component-types-sb'

import { AutoAccordion } from '../AutoAccordion/AutoAccordion'

export const HowItWorksBlock: React.FC<{
  sectionId: Section
  data: HowItWorksBlockSb
}> = ({ sectionId, data }) => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-10% 0% -50% 0%',
      threshold: 0.6,
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          useThemeStore.setState({
            activeSection: sectionId,
          })
        } else {
          if (window.scrollY < 700) {
            useThemeStore.setState({
              activeSection: 'overview',
            })
          }
        }
      })
    }, observerOptions)
    if (sectionRef?.current) {
      observer.observe(sectionRef.current)
    }
  }, [sectionRef, sectionId])

  const { sectionHeading, content } = data

  return (
    <div className="HOW-IT-WORKS-BLOCK mb-30 h-auto w-full md:mb-0" id={sectionId}>
      <div ref={sectionRef} className="h-10 w-full" />
      <AutoAccordion sectionHeading={sectionHeading} content={content} />
    </div>
  )
}
